import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import {
  GetReportResponseDto,
  GetReportsResponseDto,
  ReportClient,
  ReportFormat,
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { GetCacheOpts } from '@common-modules/cache/http-cache/http-cache.client';
import { Observable } from 'rxjs';

@Injectable()
export class ReportsService extends GeneratedClientManagerService {
  expiration: GetCacheOpts = { expiration: 'default', reload: true };

  private _reportClient: ReportClient;

  constructor(injector: Injector, private _httpClient: HttpClient) {
    super();

    this._reportClient = new ReportClient(this.httpClient, this.baseUrl);
  }

  getReportByInstances(instanceIds: string[]): Observable<GetReportsResponseDto> {
    const context = this.buildHttpContext();

    return this._reportClient.get(instanceIds, context);
  }

  getReport(
    instanceId: string,
    connectionId: string,
    reportName: string,
    format: ReportFormat
  ): Observable<GetReportResponseDto> {
    const context = this.buildHttpContext();

    return this._reportClient.getReport(instanceId, connectionId, format);
  }

  getGeneratedReport(instanceId: string, reportName: string): Observable<any> {
    const context = this.buildHttpContext();
    const url = this.baseUrl + `/api/report/${instanceId}/${reportName}`;

    return this._httpClient.get<any>(url, {
      context,
      headers: {
        Accept: 'application/octet-stream',
      },
      responseType: 'blob' as any,
    });
  }
}
